/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Bed dit team eller din administrator om support.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Vi kunne ikke hente nogen resultater for denne søgning',
};
